import { Grid } from '@mui/material'
import { SignalsCard } from './SignalsCard'
import { TestResultsCard } from './TestResultsCard'
import { UtilityCard } from './UtilityCard'

export const DataCardsRow = () => (
  <Grid container spacing={2} sx={{ width: '100%' }}>
    <Grid size={{ xs: 12, md: 4 }}>
      <TestResultsCard />
    </Grid>
    <Grid size={{ xs: 12, md: 4 }}>
      <SignalsCard />
    </Grid>
    <Grid size={{ xs: 12, md: 4 }}>
      <UtilityCard />
    </Grid>
  </Grid>
)
